module.exports = __webpack_public_path__ + "static/media/thenightly_app_download_image.6867e48f.webp";